/*
// OLD CODE - COMMENTED OUT AS REQUESTED

import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import cookies from "js-cookie";
import logoImage from "../../assets/images/logo.png";
import threeDotIcon from "../../assets/images/hamburger.png";
import "./mainHeader.css";
import DropdownMain from "../dropdown/dropdownMain";
import {
  MdKeyboardArrowUp,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";
import { HiArrowRight } from "react-icons/hi2";
import toast from "react-hot-toast";

const MainHeaderOld = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showSidebarMenu, setShowSidebarMenu] = useState(false);
  const [username, setUsername] = useState(null);
  const dropdownRef = useRef(null);

  const toggleSidebar = () => {
    setShowSidebarMenu(!showSidebarMenu);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const token = cookies.get("access");
      setShowLogin(!token);
      setIsLoggedIn(!!token);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const userData = cookies.get("userDetails");
      if (userData) {
        try {
          setUsername(JSON.parse(userData));
        } catch (e) {
          setUsername(null);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (showSidebarMenu) {
      document.body.classList.add("body-scroll-lock");
    } else {
      document.body.classList.remove("body-scroll-lock");
    }

    return () => {
      document.body.classList.remove("body-scroll-lock");
    };
  }, [showSidebarMenu]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="sticky top-0 left-0 right-0 w-full z-[999] bg-[#090817] main_header_common">
      <div className="relative z-10 bg-[#090817] sl-border">
        <nav
          className={`navbar mx-auto flex container justify-between items-center transition-all duration-300 ${
            isScrolled ? "py-[17px] md:py-[19px]" : "py-5 md:py-5"
          } px-[15px] md:px-[30px] lg:px-[30px]`}
        >
          <div className="flex items-center">
            <div
              className="w-6 w38 mt-2 pr-2 md:hidden lg:hidden block cursor-pointer"
              onClick={toggleSidebar}
            >
              <img
                src={threeDotIcon}
                alt="menu"
                width={20}
                height={20}
                className="invert"
              />
            </div>
            <Link to={process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/"}>
              <img
                src={logoImage}
                alt="logo"
                height={130}
                width={200}
                className={`header_logo object-fill transition-all duration-300 ${
                  isScrolled ? "w-[142px] h-[49px] lg:w-[180px]" : "w-[170px] height65 lg:w-[220px]"
                }`}
              />
            </Link>
          </div>
          <ul
            className={`lg:flex md:flex md:space-x-6 space-x-0 bgMob lg:space-x-6 md:space-y-0 space-y-2 lg:space-y-0 text-[#ccc] bg-[#090817] mt40 md:relative lg:relative fixed w-full md:w-auto lg:w-auto left-0 md:left-0 lg:left-0 pl-4 md:pl-0 lg:pl-0 md:top-0 lg:top-0 top-[60px] h-[99vh] md:h-auto lg:h-auto ${
              showSidebarMenu ? "menu-open" : ""
            } md:flex lg:flex`}
          >
            <li
              className="font-semibold mL10 text-[#ccc]"
              onClick={toggleSidebar}
            >
              <Link
                className="text-[#ccc]"
                to="#"
                onClick={() =>
                  (window.location.href =
                    process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/")
                }
              >
                Home
              </Link>
            </li>
            <li className="font-semibold mL10" onClick={toggleSidebar}>
              <Link
                to="#"
                onClick={() =>
                  (window.location.href =
                    process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/")
                }
              >
                About
              </Link>
            </li>
            <li ref={dropdownRef} className="text-[#ccc] pR10 relative">
              <button
                className="relative text-[#ccc] font-semibold mL10 flex items-center"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                Products{" "}
                {!isDropdownOpen ? (
                  <MdOutlineKeyboardArrowDown
                    size={20}
                    className="text-white"
                  />
                ) : (
                  <MdKeyboardArrowUp size={20} className="text-white" />
                )}
              </button>
              {isDropdownOpen && (
                <div className="md:absolute lg:absolute relative md:mt-2 lg:mt-2 bg-[#272737] border border-pink-500 text-white mt-0 z-10 md:shadow-md lg:shadow-md shadow-none lg:p-2 md:p-2 p-0 rounded-md pr20">
                  <Link
                    to="#"
                    onClick={() => {
                      const access = cookies.get("access");
                      const targetUrl = access
                        ? process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL +
                          "/search-table"
                        : process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL +
                          "/login";
                      window.location.href = targetUrl;
                      setIsDropdownOpen(false);
                      setShowSidebarMenu(false);
                    }}
                    className="block px-4 py-1 hover:bg-pink-500 textWhite"
                  >
                    Testing
                  </Link>
                  <Link
                    to="#"
                    onClick={() => {
                      const access = cookies.get("access");
                      if (!access) {
                        window.location.href =
                          process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL +
                          "/login";
                        setIsDropdownOpen(false);
                        setShowSidebarMenu(false);
                        return;
                      }
                      window.location.href =
                        process.env.REACT_APP_PUBLIC_CERTIFICATION_NAVBAR_ROUTE_URL;
                      setIsDropdownOpen(false);
                      setShowSidebarMenu(false);
                    }}
                    className="block px-4 py-1 hover:bg-pink-500 textWhite"
                  >
                    Certification
                  </Link>
                  <Link
                    to="#"
                    onClick={() => {
                      window.location.href =
                        process.env.REACT_APP_PUBLIC_PROJECTS_NAVBAR_ROUTE_URL;
                      setIsDropdownOpen(false);
                      setShowSidebarMenu(false);
                    }}
                    className="block px-4 py-1 hover:bg-pink-500 textWhite"
                  >
                    Collaborate
                  </Link>
                  <Link
                    to="#"
                    onClick={() => {
                      const access = cookies.get("access");

                      if (!access) {
                        toast("Please log in to access this section.");
                        setIsDropdownOpen(false);
                        setShowSidebarMenu(false);
                        return;
                      }
                      window.location.href =
                        process.env.REACT_APP_PUBLIC_SERVICES_NAVBAR_ROUTE_URL;
                      setIsDropdownOpen(false);
                      setShowSidebarMenu(false);
                    }}
                    className="block px-4 py-1 hover:bg-pink-500 textWhite"
                  >
                    Analyze & Report
                  </Link>
                  <Link
                    to="#"
                    onClick={() => {
                      const access = cookies.get("access");

                      if (!access) {
                        toast("Please log in to access this section.");
                        setIsDropdownOpen(false);
                        setShowSidebarMenu(false);
                        return;
                      }
                      window.location.href =
                        process.env.REACT_APP_PUBLIC_ASKAI_PROD_URL;
                      setIsDropdownOpen(false);
                      setShowSidebarMenu(false);
                    }}
                    className="block px-4 py-1 hover:bg-pink-500 textWhite"
                  >
                    Biz Dev
                  </Link>
                  <Link
                    to="#"
                    onClick={() => {
                      window.location.href = "/remote";
                      setIsDropdownOpen(false);
                      setShowSidebarMenu(false);
                    }}
                    className="block px-4 py-1 hover:bg-pink-500 textWhite"
                  >
                    Remote
                  </Link>
                  <Link
                    to="#"
                    onClick={() => {
                      const access = cookies.get("access");

                      if (!access) {
                        toast("Please log in to access this section.");
                        setIsDropdownOpen(false);
                        setShowSidebarMenu(false);
                        return;
                      }

                      const planName = cookies.get("planName");
                      if (planName === "true") {
                        window.open(
                          process.env.REACT_APP_PUBLIC_GOVT_URL,
                          "_blank"
                        );
                      } else {
                        toast(
                          "Only Premium and Plus plan users can access this section."
                        );
                      }
                      setIsDropdownOpen(false);
                      setShowSidebarMenu(false);
                    }}
                    className="block px-4 py-1 hover:bg-pink-500 textWhite"
                  >
                    Government
                  </Link>
                </div>
              )}
            </li>

            <li className="font-semibold mL10" onClick={toggleSidebar}>
              <Link
                to="#"
                onClick={() =>
                  (window.location.href =
                    process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/")
                }
              >
                Resources
              </Link>
            </li>
            <li className="font-semibold mL10 mobpb10" onClick={toggleSidebar}>
              <Link to="https://crosslinker.us/pricing-plans">Pricing</Link>
            </li>
          </ul>
          <div className="flex gap-2 items-center">
            {!isLoggedIn && showLogin !== null && showLogin && (
              <div className="flex space-x-2 md:space-x-4 lg:space-x-3">
                <a
                  href={`${
                    process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || ""
                  }/login`}
                  className="text-xs md:text-sm lg:text-sm font-medium rounded-full px-5 py-1.5 text-white border border-gray-600 hover:border-white hover:bg-white/5 transition duration-300 flex items-center justify-center"
                >
                  Log In
                </a>
                <a
                  href={`${
                    process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || ""
                  }/sign-up`}
                  className="main_btn text-xs md:text-sm lg:text-sm flex items-center hover:text-white mL10 py-1.5 px-4 rounded-full font-medium"
                >
                  Sign Up <HiArrowRight className="w-4 h-4 ml-1.5 inline-block" />
                </a>
              </div>
            )}

            {isLoggedIn && (
              <div className="submenu flex items-center">
                <ul className="flex items-center justify-end header_dropdown_button after_login_menu">
                  <span className="text-white header_username mr-3 hidden md:block font-medium">
                    {username?.full_name ? username.full_name : "User"}
                  </span>
                  <li className="inline">
                    <DropdownMain userData={username} />
                  </li>
                </ul>
              </div>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};
*/

// NEW CODE - CONVERTED TO JSX FOR REACT SPA

import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logoImage from "../../assets/images/logo.png";
import threeDotIcon from "../../assets/images/hamburger.png";
import cookies from "js-cookie";
import toast from "react-hot-toast";
import {
  MdVerified,
  MdOutlineBarChart,
  MdOutlineKeyboardArrowDown,
  MdScience,
  MdAccountBalance,
  MdOutlineDevices,
  MdAutoAwesome,
  MdPeople,
  MdClose,
} from "react-icons/md";
import { HiArrowRight } from "react-icons/hi2";

import DropdownMain from "../dropdown/dropdownMain";
import CurrencyDropdown from "../dropdown/CurrencyDropdown";
import "./mainHeader.css";

const dropdownItemClass =
  "glass-option flex w-full cursor-pointer items-start rounded-lg px-3 py-2.5 text-left text-white transition-all duration-200 hover:bg-white/10 hover:border-white/20 border border-transparent focus-visible:outline-none";

const ProductRow = ({ icon: Icon, title, description }) => (
  <>
    <Icon
      size={16}
      className="mr-2 mt-0.5 h-4 w-4 flex-none text-gray-400"
      aria-hidden="true"
    />
    <span className="min-w-0">
      <span className="block text-sm leading-tight">{title}</span>
      <span className="mt-0.5 block text-xs leading-snug text-gray-400">
        {description}
      </span>
    </span>
  </>
);

const MainHeader = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const [scrolled, setScrolled] = useState(false);

  const isActive = (href) =>
    href === "/" ? pathname === "/" : pathname.startsWith(href);

  const productRoutes = ["/search-table", "/remote"];
  const isProductActive = productRoutes.some((r) => pathname.startsWith(r));

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [showSidebarMenu, setShowSidebarMenu] = useState(false);
  const dropdownRef = useRef(null);
  const [canHover, setCanHover] = useState(false);
  const closeTimer = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    setCanHover(window.matchMedia("(hover: hover) and (pointer: fine)").matches);

    const mobile = window.matchMedia("(max-width: 767.98px)");
    const sync = () => setIsMobile(mobile.matches);
    sync();
    mobile.addEventListener("change", sync);

    return () => {
      mobile.removeEventListener("change", sync);
      if (closeTimer.current) clearTimeout(closeTimer.current);
    };
  }, []);

  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const publish = () => {
      document.documentElement.style.setProperty(
        "--header-h",
        `${el.offsetHeight}px`,
      );
    };
    const observer = new ResizeObserver(publish);
    observer.observe(el);
    publish();
    return () => observer.disconnect();
  }, []);

  const openProductsOnHover = () => {
    if (!canHover) return;
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setIsDropdownOpen(true);
  };

  const closeProductsOnHover = () => {
    if (!canHover) return;
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setIsDropdownOpen(false), 140);
  };

  const toggleSidebar = () => {
    setShowSidebarMenu(!showSidebarMenu);
  };

  const closeSidebar = () => setShowSidebarMenu(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const token = cookies.get("access");
      setShowLogin(!token);
      setIsLoggedIn(!!token);
      const userData = cookies.get("userDetails");
      if (userData) {
        try {
          setCustomer(JSON.parse(userData));
        } catch (e) {
          setCustomer(null);
        }
      }
    }
  }, []);

  useEffect(() => {
    setIsDropdownOpen(false);
    setShowSidebarMenu(false);
  }, [pathname]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key !== "Escape") return;
      setIsDropdownOpen(false);
      setShowSidebarMenu(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  useEffect(() => {
    if (showSidebarMenu) {
      document.body.classList.add("body-scroll-lock");
    } else {
      document.body.classList.remove("body-scroll-lock");
    }

    return () => {
      document.body.classList.remove("body-scroll-lock");
    };
  }, [showSidebarMenu]);

  return (
    <div
      ref={headerRef}
      className={`main_header_common fixed w-full top-0 left-0 right-0 shadow-md z-[999999] ${
        scrolled ? "header_scrolled" : ""
      }`}
    >
      <div className="relative z-[999999]">
        <nav className="navbar container mx-auto flex justify-between items-center gap-3 py-4">
          <div className="flex items-center">
            <button
              type="button"
              className="mt-1 mr-2 grid h-9 w-9 place-items-center rounded-full transition-colors hover:bg-white/10 md:!hidden"
              aria-label={showSidebarMenu ? "Close menu" : "Open menu"}
              aria-expanded={showSidebarMenu}
              aria-controls="primary-menu"
              onClick={toggleSidebar}
            >
              {showSidebarMenu ? (
                <MdClose size={20} className="text-white" />
              ) : (
                <img
                  src={threeDotIcon}
                  alt=""
                  width={20}
                  height={20}
                  className="invert"
                />
              )}
            </button>
            <Link to="/" aria-label="Crosslinker Labs home" className="shrink-0">
              <img
                src={logoImage}
                alt="Crosslinker Labs"
                width={440}
                height={154}
                className="nav_logo"
              />
            </Link>
          </div>

          <div className="flex justifyEnd items-center w-fullMob flex-1 min-w-0 tabmobwidht justify-between space-x-4 flexStart">
            <ul
              id="primary-menu"
              aria-hidden={isMobile && !showSidebarMenu ? true : undefined}
              className={`lg:flex md:flex md:space-x-6 bgMob pt10
  md:flex-1 md:justify-center md:ml-6 lg:ml-10
  space-x-0 lg:space-x-6 md:space-y-0 space-y-2 lg:space-y-0
  text-[#ebebeb]
  md:relative lg:relative
  fixed w-full left-0 md:left-0 lg:left-0
  md:w-auto lg:w-auto
  md:top-0 lg:top-0
  md:h-auto lg:h-auto
  pl-3 md:pl-0 lg:pl-0
  ${showSidebarMenu ? "menu-open" : ""}
  md:flex lg:flex`}
            >
              <li className="font-medium mL10">
                <a
                  href={process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "/"}
                  className="nav_link"
                  onClick={closeSidebar}
                >
                  Home
                </a>
              </li>
              <li className="font-medium mL10">
                <a
                  href="https://crosslinker.us/about-us"
                  className="nav_link"
                  onClick={closeSidebar}
                >
                  About
                </a>
              </li>
              <li
                ref={dropdownRef}
                className="mL10 pr20 relative"
                onMouseEnter={openProductsOnHover}
                onMouseLeave={closeProductsOnHover}
              >
                <button
                  className={`nav_link font-medium inline-flex items-center gap-1 whitespace-nowrap ${
                    isProductActive ? "is-active" : ""
                  }`}
                  aria-haspopup="true"
                  aria-expanded={isDropdownOpen}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <span>Products</span>
                  <MdOutlineKeyboardArrowDown
                    size={16}
                    aria-hidden="true"
                    className={`shrink-0 transition-transform duration-200 ${
                      isDropdownOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isDropdownOpen && (
                  <div
                    role="menu"
                    className="nav-products-menu glass-panel absolute top-full md:mt-2 lg:mt-2 textWhite text-white mt-2 z-[9999999] p-2 rounded-md w-[320px] md:w-[360px] right-0 overflow-hidden bg-[#121124] shadow-2xl border border-white/20"
                  >
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const access = cookies.get("access");
                        const targetUrl = access
                          ? (process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "") + "/search-table"
                          : (process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "") + "/login";
                        window.location.href = targetUrl;
                        closeSidebar();
                        setIsDropdownOpen(false);
                      }}
                      className={`${dropdownItemClass} ${
                        isActive("/search-table") ? "is-selected" : ""
                      }`}
                    >
                      <ProductRow icon={MdScience} title="Testing" description="Book instrument time at labs worldwide" />
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const access = cookies.get("access");
                        const targetUrl = access
                          ? (process.env.REACT_APP_PUBLIC_CERTIFICATION_NAVBAR_ROUTE_URL || "")
                          : (process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || "") + "/login";
                        window.location.href = targetUrl;
                        closeSidebar();
                        setIsDropdownOpen(false);
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow icon={MdVerified} title="Certification" description="Compliance and certification workflows" />
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = process.env.REACT_APP_PUBLIC_PROJECTS_NAVBAR_ROUTE_URL || "https://projects.crosslinker.us/";
                        closeSidebar();
                        setIsDropdownOpen(false);
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow icon={MdPeople} title="Collaborate" description="Run joint research projects in one place" />
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const access = cookies.get("access");
                        if (!access) {
                          toast("Please log in to access this section.");
                          setIsDropdownOpen(false);
                          closeSidebar();
                          return;
                        }
                        window.location.href = process.env.REACT_APP_PUBLIC_SERVICES_NAVBAR_ROUTE_URL || "https://service.crosslinker.us/";
                        closeSidebar();
                        setIsDropdownOpen(false);
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow icon={MdOutlineBarChart} title="Analyze & Report" description="Turn raw results into shareable reports" />
                    </a>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        const access = cookies.get("access");
                        if (!access) {
                          toast("Please log in to access this section.");
                          setIsDropdownOpen(false);
                          closeSidebar();
                          return;
                        }
                        window.location.href = process.env.REACT_APP_PUBLIC_ASKAI_PROD_URL || "";
                        closeSidebar();
                        setIsDropdownOpen(false);
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow icon={MdAutoAwesome} title="Biz Dev" description="AI matchmaking for labs and buyers" />
                    </a>
                    <Link
                      to="/remote"
                      aria-current={isActive("/remote") ? "page" : undefined}
                      onClick={() => {
                        closeSidebar();
                        setIsDropdownOpen(false);
                      }}
                      className={`${dropdownItemClass} ${
                        isActive("/remote") ? "is-selected" : ""
                      }`}
                    >
                      <ProductRow icon={MdOutlineDevices} title="Remote" description="Operate instruments without leaving your desk" />
                    </Link>
                    <button
                      type="button"
                      onClick={() => {
                        const access = cookies.get("access");

                        if (!access) {
                          toast("Please log in to access this section.");
                          setIsDropdownOpen(false);
                          closeSidebar();
                          return;
                        }

                        const planName = cookies.get("planName");
                        if (planName === "true") {
                          window.open(
                            process.env.REACT_APP_PUBLIC_GOVT_URL,
                            "_blank",
                          );
                          setIsDropdownOpen(false);
                          closeSidebar();
                        } else {
                          toast(
                            "Only Premium and Plus plan users can access this section.",
                          );
                          setIsDropdownOpen(false);
                          closeSidebar();
                        }
                      }}
                      className={dropdownItemClass}
                    >
                      <ProductRow icon={MdAccountBalance} title="Government" description="Premium and Plus plans only" />
                    </button>
                  </div>
                )}
              </li>
              <li className="font-medium mL10">
                <a
                  href="https://crosslinker.us/case-studies"
                  className="nav_link"
                  onClick={closeSidebar}
                >
                  Resources
                </a>
              </li>
              <li className="font-medium mL10">
                <a
                  href="https://crosslinker.us/pricing-plans"
                  className="nav_link"
                  onClick={closeSidebar}
                >
                  Pricing
                </a>
              </li>
            </ul>

            <div className="flex items-center gap-2.5 mL10">
              <CurrencyDropdown />

              {!isLoggedIn && (
                <>
                  {showLogin !== null && showLogin && (
                    <div className="flex space-x-1 md:space-x-4 lg:space-x-3">
                      <a
                        href={`${
                          process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || ""
                        }/login`}
                        className="text-xs md:text-sm lg:text-sm font-medium rounded-full px-5 py-1.5 text-white border border-gray-600 hover:border-white hover:bg-white/5 transition duration-300 flex items-center justify-center"
                      >
                        Log In
                      </a>
                      <a
                        href={`${
                          process.env.REACT_APP_PUBLIC_TESTING_NAVBAR_ROUTE_URL || ""
                        }/sign-up`}
                        className="main_btn text-xs md:text-sm lg:text-sm flex items-center hover:text-white mL10 py-1.5 px-4 rounded-full font-medium"
                      >
                        Sign Up <HiArrowRight className="w-4 h-4 ml-1.5 inline-block" />
                      </a>
                    </div>
                  )}
                </>
              )}

              {isLoggedIn && (
                <div className="flex items-center">
                  <DropdownMain userData={customer} />
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MainHeader;
